import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Link } from 'shared-routing';
import { BackgroundImgixWrapper } from '@common/components/BackgroundImgixWrapper';
import { Button } from '..';

const Banner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 100%;
  margin: 10px 0;
  ${({ background }) =>
    !background &&
    css`
      background-color: ${({ theme }) => theme.customColors.tertiary};
    `}
`;

const SectionBanner = ({ route, label, backgroundImage = null }) => (
  <BackgroundImgixWrapper src={backgroundImage && backgroundImage.url}>
    <Banner background={backgroundImage}>
      <Link route={route}>
        <Button>{label}</Button>
      </Link>
    </Banner>
  </BackgroundImgixWrapper>
);

SectionBanner.propTypes = {
  route: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]).isRequired,
  backgroundImage: PropTypes.shape({
    url: PropTypes.string,
  }),
};

export default SectionBanner;
